import { cardAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

import { metricCardLayout } from '../tokens/metricCard'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(cardAnatomy.keys)

const baseStyle = definePartsStyle({
  container: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'presets.neutral.20',
    borderRadius: '8',
    overflow: 'hidden',
    backgroundColor: 'white',
    shadow: 'none',
  },
  header: {
    py: '14px',
    px: '16px',
    borderBottom: '1px',
    borderColor: 'presets.neutral.20',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  body: {
    p: '16px 16px 16px',
  },
})

const variants = {
  info: definePartsStyle({
    container: {
      backgroundColor: 'presets.blue.10',
      borderColor: 'presets.blue.50',
      _dark: {
        backgroundColor: 'component.metricCard.dark.background',
        borderColor: 'component.metricCard.dark.borderColor',
        '--bento-separator-color':
          'var(--chakra-colors-component-metricCard-dark-separatorColor)',
        backdropFilter: `blur(${metricCardLayout.backdropBlur})`,
      },
    },
    header: {
      borderColor: 'presets.blue.50',
      _dark: {
        borderColor: 'component.metricCard.dark.borderColor',
      },
    },
  }),
  disabled: definePartsStyle({
    container: {
      bg: 'presets.neutral.10',
      borderColor: 'presets.neutral.20',
    },
    body: {
      color: 'presets.neutral.80',
      fontSize: '14px',
      fontWeight: 500,
    },
  }),
  /**
   * TODO: rename `shark` — placeholder name.
   */
  shark: definePartsStyle({
    container: {
      borderRadius: '12px',
      borderWidth: '0',
      borderColor: 'transparent',
      backgroundColor: 'transparent',
      shadow: 'none',
      backdropFilter: 'none',
      _dark: {
        backgroundColor: 'rgba(255, 255, 255, 0.13)',
        borderWidth: '0',
        borderColor: 'transparent',
        backdropFilter: 'none',
      },
    },
    body: {
      px: '16px',
      pt: '14px',
      pb: '16px',
    },
  }),
}

export const cardTheme = defineMultiStyleConfig({ baseStyle, variants })
